import { getPillarIndicator } from '../helpers';
import { IIndicatorStatus } from '../interfaces';

export const getCashflowIndicator = (
  savingsRatioIndicator: IIndicatorStatus,
  totalDebtServicingRatioIndicator: IIndicatorStatus
) => getPillarIndicator(savingsRatioIndicator, totalDebtServicingRatioIndicator);
